import Scopes from "../../../../src/blog/vs-code-theme-with-style-dictionary/Scopes";
import Tip from "$components/Tip";
import * as React from 'react';
export default {
  Scopes,
  Tip,
  React
};